import { DefaultTheme } from 'styled-components';
import { ThemeEnum } from '@app/common';
import { getOpacity } from '../utils/get-rgb';
import { createAssetColor } from './color-create';

export const createIconPortfolio = (t: ThemeEnum) => {
    const assetColor = createAssetColor(t);

    const variant = Object.entries(assetColor).reduce((acc, [key, value]) => {
        acc[key as keyof DefaultTheme['iconPortfolio']['variant']] = {
            base: {
                background: value.main,
                border: value.main,
                color: value.text,
            },
            hover: {
                background: value.darken,
                border: value.darken,
                color: value.text,
            },
            active: {
                background: value.dark,
                border: value.dark,
                color: value.text,
            },
            disabled: {
                background: getOpacity(value.light, 0.4),
                border: getOpacity(value.light, 0.4),
                color: getOpacity(value.text, 0.4),
            },
        };

        return acc;
    }, {} as DefaultTheme['iconPortfolio']['variant']);

    const iconPortfolio: DefaultTheme['iconPortfolio'] = {
        size: {
            xsmall: {
                icon: '1.2rem',
                wrapper: '3.0rem',
            },
            vsmall: {
                icon: '1.4rem',
                wrapper: '3.2rem',
            },
            small: {
                icon: '1.6rem',
                wrapper: '3.6rem',
            },
            medium: {
                icon: '1.8rem',
                wrapper: '4.0rem',
            },
            large: {
                icon: '2.4rem',
                wrapper: '4.8rem',
            },
            vlarge: {
                icon: '2.8rem',
                wrapper: '5.2rem',
            },
            xlarge: {
                icon: '3.8rem',
                wrapper: '6.2rem',
            },
        },
        variant,
    };
    return iconPortfolio;
};
